module.exports = __webpack_public_path__ + "static/media/icn-aluminio-02.8ef75dfd.svg";